import React from 'react';
import 'core-js/features/string/replace-all';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import './index.scss';
// import ReactGA from 'react-ga';
import ReactGA from 'react-ga4';
import { createStore } from 'redux';
import rootReducer from './reducers';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import './language/i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; //PWA
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';
import TiktokPixel from 'tiktok-pixel';

TiktokPixel.init('CPBV32BC77U97SP6COMG');

serviceWorkerRegistration.unregister();
// const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID; // 발급받은 추적ID를 환경 변수로 불러온다.

const GoogleTagManager = {
  gtmId: 'GTM-TV3Q4MH2',
};

TagManager.initialize(GoogleTagManager);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
if (!window.location.hostname.includes('localhost'))
    Sentry.init({
        dsn: 'https://f5be404906bf5a82f56331cc4edb5d29@sentry.shorton.kr/22',
        // 성능 모니터링 설정
        integrations: [
            Sentry.browserTracingIntegration(),
            // Session Replay: 사용자 행동 재현 기능
            Sentry.replayIntegration({
                // 개인정보 보호를 위해 모든 텍스트를 가립니다.
                maskAllText: true,
                // 모든 CSS 인풋(input) 요소를 가립니다.
                blockAllMedia: true,
            }),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.1,
        // Session Replay 수집 비율
        // 전체 세션의 10%를 녹화
        replaysSessionSampleRate: 0.1,
        // 에러가 발생한 세션은 100% 녹화
        replaysOnErrorSampleRate: 1.0,
        environment: 'WEB'
    });
const queryClient = new QueryClient();

const store = createStore(rootReducer);
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>,
);
